import { render, staticRenderFns } from "./zatca-invoices.vue?vue&type=template&id=3b6de2e5&scoped=true"
import script from "./zatca-invoices.vue?vue&type=script&lang=js"
export * from "./zatca-invoices.vue?vue&type=script&lang=js"
import style0 from "./zatca-invoices.vue?vue&type=style&index=0&id=3b6de2e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6de2e5",
  null
  
)

export default component.exports